export { default } from './component';

